/* hanzo.lt: auto free gift for the "Slaptas pasiulymas" pan.
   Rule: cart contains product 11204577853783 AND cart total >= 100 EUR
   -> add gift variant 53734331482455 (0,00 EUR) automatically.
   Gift is removed if the pan is removed or total drops below 100 EUR.
   The auto-added line is marked with property _hz_auto_gift. */
(function () {
  'use strict';
  if (!location.hostname.includes('hanzo.lt')) return;
  var PAN_PRODUCT_ID = 11204577853783;
  var GIFT_VARIANT_ID = 53734331482455;
  var THRESHOLD_CENTS = 10000; // 100 EUR
  var busy = false;

  function sync() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasPan = false, giftLine = null, giftAuto = false;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.product_id === PAN_PRODUCT_ID) hasPan = true;
          if (it.variant_id === GIFT_VARIANT_ID) {
            giftLine = it;
            giftAuto = !!(it.properties && it.properties._hz_auto_gift);
          }
        }
        var totalWithoutGift = cart.total_price; // gift is 0.00, does not affect total
        var eligible = hasPan && totalWithoutGift >= THRESHOLD_CENTS;

        if (eligible && !giftLine) {
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1, properties: { _hz_auto_gift: '1' } })
          });
        }
        if (giftLine && (!eligible && giftAuto)) {
          return fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftLine.key, quantity: 0 })
          });
        }
        if (giftLine && giftLine.quantity > 1) {
          return fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftLine.key, quantity: 1 })
          });
        }
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); setInterval(sync, 3000); });
  } else {
    sync(); setInterval(sync, 3000);
  }
})();
